'use client';
import React from 'react';
import AnimatedGradientButton from './AnimatedGradientButton';

interface ColorBoxProps {
  title: string;
  description: React.ReactNode;
  className?: string;
  buttonText?: string;
  buttonHref?: string;
}

const ColorBox: React.FC<ColorBoxProps> = ({
  buttonHref,
  buttonText,
  className = '',
  description,
  title,
}) => {
  return (
    <div
      data-name="color-box"
      className={`mb-10 w-full overflow-hidden rounded-[20px] bg-[linear-gradient(155.8deg,#FFFFFF_-36%,#A18FEB_-11.6%,#C53C0E_95.92%)] p-[46px_44px] sm:max-w-[530px] ${className}`}
    >
      <div className="flex flex-col">
        <h4 className="font-['Spectral'] text-[24px] leading-[40px] font-semibold tracking-[-5%] text-white">
          {title}
        </h4>
        <div className="mt-2 h-px w-[60%] border border-white opacity-70" />
        <p className="mt-6 font-['Work_Sans'] text-[16px] leading-[20px] font-normal tracking-[0%] text-white">
          {description}
        </p>
        {buttonText && buttonHref && (
          <div className="mt-6">
            <AnimatedGradientButton
              href={buttonHref}
              as="link"
              theme="purple"
              text={buttonText}
              className="min-w-[140px]"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ColorBox;
